import React, { useState, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Drawer, Table, Popconfirm,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import FormCustomStatus from './FormCustomStatus';
import './style.scss';
import Lottie from 'lottie-react';
import restrictedLock from '../../../../media/lotties/restrictedLock.json';

/**
 *
 */
const CustomStatus = ({
  user, getCustomStatus, customStatusSalesOrder, customStatusInvoice, deleteCustomStatus, customStatusConsumption, getOrgStatusConsumptionLoading,customStatusAnnualMaintenanceContract, getOrgStatusAnnualMaintenanceContractLoading,
  getCustomStatusSalesOrderLoading, getCustomStatusInvoiceLoading, type, deleteCustomStatusLoading, customStatusSalesEstimate, getCustomStatusSalesEstimateLoading, customStatusPackingSlip, getCustomStatusPackingSlipLoading, customStatusDeliveryChallan, getCustomStatusDeliveryChallanLoading,
}) => {
  const [showCreateStatusDrawer, setShowCreateStatusDrawer] = useState(false);
  const [showUpdateStatusDrawer, setShowUpdateStatusDrawer] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [call, setCall] = useState(false);

  useEffect(() => {
    getCustomStatus({
      entityName: type,
      orgId: user?.tenant_info?.org_id,
    }, () => { });
  }, [call]);

  const columns = [
    {
      title: 'Stage',
      render: (record) => <div>{record?.type?.replace(/_/g, ' ')?.toProperCase()}</div>,
    },
    {
      title: 'Status',
      render: (record) => (
        <div className="status-tag" style={{ backgroundColor: record?.color_code }}>
          {record?.status_name?.replaceAll('_', ' ')?.toProperCase()}
        </div>
      ),
    },
    {
      title: 'Is it Default?',
      render: (record) => (record?.is_default ? (
        <div style={{ color: 'green' }}>
          <FontAwesomeIcon icon={faCircleCheck} />
        </div>
      ) : '-'),
    },
    {
      title: 'Is it Final?',
      render: (record) => (record?.is_final ? (
        <div style={{ color: 'green' }}>
          <FontAwesomeIcon icon={faCircleCheck} />
        </div>
      ) : '-'),
    },
    {
      title: 'Allowed from statuses?',
      render: (record) => (
        <div>
          <H3Text text={record?.type?.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')} className="" />
        </div>
      ),
    },
    {
      title: '',
      render: (record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setSelectedStatus(record);
              setShowUpdateStatusDrawer(true);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this reason?"
            onConfirm={() => deleteCustomStatus({ custom_status_id: record?.custom_status_id, org_id: user?.tenant_info?.org_id },
              () => setCall(!call))}
            okText="Yes"
            cancelText="No"
          >
            <div
              className="deleteButton"
            >
              <DeleteOutlined />
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  function getCSTypeData(entityTypes) {
    switch (entityTypes) {
      case 'SALES_ESTIMATE':
        return customStatusSalesEstimate;
      case 'SALES_ORDER':
        return customStatusSalesOrder;
      case 'PACKING_SLIP':
        return customStatusPackingSlip;
      case 'INVOICE':
        return customStatusInvoice;
      case 'CONSUMPTION_ORDER':
        return customStatusConsumption;
      case 'ANNUAL_MAINTENANCE_CONTRACT':
        return customStatusAnnualMaintenanceContract;
      case 'DELIVERY_CHALLAN':
        return customStatusDeliveryChallan;  
      default:
        return {};
    }
  }

  function getCSTypeLoading(entityTypes) {
    switch (entityTypes) {
      case 'SALES_ESTIMATE':
        return getCustomStatusSalesEstimateLoading;
      case 'SALES_ORDER':
        return getCustomStatusSalesOrderLoading;
      case 'PACKING_SLIP':
        return getCustomStatusPackingSlipLoading;
      case 'INVOICE':
        return getCustomStatusInvoiceLoading;
      case 'CONSUMPTION_ORDER':
        return getOrgStatusConsumptionLoading;
      case 'ANNUAL_MAINTENANCE_CONTRACT':
        return getOrgStatusAnnualMaintenanceContractLoading;
      case 'DELIVERY_CHALLAN':
        return getCustomStatusDeliveryChallanLoading;
      default:
        return false;
    }
  }

  const customStatus = user?.tenant_info?.global_config?.sub_modules?.custom_status?.is_active;

  return (
    <Fragment>
      <Drawer
        open={showCreateStatusDrawer}
        width="360px"
        mask
        onClose={() => setShowCreateStatusDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New Custom Status" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowCreateStatusDrawer(false)} />
          </div>
        </div>
        <div className="create-cs__new-cs-wrapper">
          <FormCustomStatus
            entity={type}
            callback={() => {
              setShowCreateStatusDrawer(false);
              setCall(!call);
            }}
            possibleFromStatuses={getCSTypeData(type)?.statuses}
          />
        </div>
      </Drawer>
      <Drawer
        open={showUpdateStatusDrawer}
        width="360px"
        mask
        onClose={() => setShowUpdateStatusDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update Custom Status" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateStatusDrawer(false)} />
          </div>
        </div>
        <div className="create-cs__new-cs-wrapper">
          <FormCustomStatus
            callback={() => {
              setShowUpdateStatusDrawer(false);
              setCall(!call);
            }}
            entity={type}
            selectedStatus={selectedStatus}
            possibleFromStatuses={getCSTypeData(type)?.statuses}
          />
        </div>
      </Drawer>
      <div className="restrict-status">
        {!customStatus && (
          <div className="restrict-status__wrapper">
            <div className="restrict-status-overlay">
              <div className="restrict-status-content__wrapper">
                <div className="restrict-status-content">
                  <div className="restrict-status-lock__wrapper">
                    <div className="restrict-status-lock">
                      <Lottie
                        animationData={restrictedLock}
                        loop
                      />
                    </div>
                  </div>
                  <div className="restrict-status-text-head">Premium Feature</div>
                  <div className="restrict-status-text-body">
                    Custom Statuses feature is not available in your current plan.
                  </div>
                  <div className="restrict-status-contact-button__wrapper">
                    <div className="restrict-status-contact-button">
                      <a href="mailto:sales@procuzy.com" target="_blank" rel="noreferrer">
                        Contact Us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="ant-row">
          <div className="ant-col-md-24">
            <div className="generic-table-container" style={{ margin: '0px !important' }}>
              <Table
                title={() => (
                  <div style={{ display: 'flex', justifyContent: 'space-between', 'align-items': 'baseline' }}>
                    {`${getCSTypeData(type)?.statuses?.length || 0} ${type?.replaceAll('_', ' ')?.toProperCase()} Statuses`}
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Status"
                      onClick={() => setShowCreateStatusDrawer(true)}
                      customClass="cr__header__add-button hide__in-mobile"
                    />
                  </div>
                )}
                columns={columns}
                size="small"
                scroll="scroll"
                loading={getCSTypeLoading(type) || deleteCustomStatusLoading}
                dataSource={getCSTypeData(type)?.statuses || []}
                pagination={getCSTypeData(type)?.statuses?.length > 10}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CustomStatusReducers }) => ({
  user: UserReducers.user,
  customStatusSalesOrder: CustomStatusReducers.customStatusSalesOrder,
  customStatusInvoice: CustomStatusReducers.customStatusInvoice,
  customStatusConsumption: CustomStatusReducers.customStatusConsumption,
  getOrgStatusConsumptionLoading: CustomStatusReducers.getOrgStatusConsumptionLoading,
  getCustomStatusSalesOrderLoading: CustomStatusReducers.getCustomStatusSalesOrderLoading,
  getCustomStatusInvoiceLoading: CustomStatusReducers.getCustomStatusInvoiceLoading,
  deleteCustomStatusLoading: CustomStatusReducers.deleteCustomStatusLoading,
  getCustomStatusSalesEstimateLoading: CustomStatusReducers.getCustomStatusSalesEstimateLoading,
  customStatusSalesEstimate: CustomStatusReducers.customStatusSalesEstimate,
  customStatusPackingSlip: CustomStatusReducers.customStatusPackingSlip,
  getCustomStatusPackingSlipLoading: CustomStatusReducers.getCustomStatusPackingSlipLoading,
  getCustomStatusConsumptionLoading: CustomStatusReducers.getCustomStatusConsumptionLoading,
  customStatusAnnualMaintenanceContract: CustomStatusReducers.customStatusAnnualMaintenanceContract,
  getOrgStatusAnnualMaintenanceContractLoading: CustomStatusReducers.getOrgStatusAnnualMaintenanceContractLoading,
  customStatusDeliveryChallan: CustomStatusReducers.customStatusDeliveryChallan,
  getCustomStatusDeliveryChallanLoading: CustomStatusReducers.getCustomStatusDeliveryChallanLoading,

});

const mapDispatchToProps = (dispatch) => ({
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  deleteCustomStatus: (payload, callback) => dispatch(CustomStatusActions.deleteCustomStatus(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomStatus));
